import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdHealthAndSafety } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa";
import { FaEnvira } from "react-icons/fa";
import Api from '../function/axiosInterceptor';
let Trustee = () => {
    const [about, setAbout] = useState({ what_we_do: [{ sno: '', title: '', content: ''}],banner: [{ sno: '',image: '' }] });
    useEffect(()=>{
        Api.get('/abouts').then((response)=>{
            if(response.status==='success'){
                setAbout(response.data);
            }else{
                console.log('Error Api: '+response.status);
            }
        }).catch((error)=>{
            console.log(error);
        })
    },[])
    return (
        <>
            <section>
                <div className="breadcrumb-area" style={{ backgroundImage: "url("+process.env.REACT_APP_IMG_BASE_URL+"/img/"+about?.banner[0]?.image+")" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner">
                                    <h2 className="page-title">Trustee</h2>
                                    <ul className="page-list">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="">Trustee</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                  </section>

                 <section className="problem-area padding-top-90 padding-bottom-85">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-8 col-sm-11 col-11">
                                            <div className="section-title b-top desktop-center padding-top-25 margin-bottom-55">
                                                
                                                <h2 className="title mb-1">MNB Foundation — Board of Trustees</h2>
                                                <p>At MNB Foundation, our Board of Trustees provides strategic leadership, governance, and ensures that our mission of community empowerment, education, health support, and rural upliftment is delivered with integrity and impact.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row d-flex">
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/1.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Jwala Kumar Pandey</h5>
         <h6 class="text-muted font-16 mt-1">President</h6>
      </div>
     
   </div>
</div>
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/2.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mrs. Rupa Kumari </h5>
         <h6 class="text-muted font-16">Vice President</h6>
      </div>
     
   </div>
</div>
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/3.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Akhilesh Srivastava</h5>
         <h6 class="text-muted font-16">Secratary</h6>
      </div>
     
   </div>
</div>
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/4.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Amarnath Tiwari</h5>
         <h6 class="text-muted font-16">Assistant Secretary</h6>
      </div>
     
   </div>
</div>

<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/5.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Sonu Kumar</h5>
         <h6 class="text-muted font-16">Treasurer</h6>
      </div>
     
   </div>
</div>
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/6.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Parmanand Chaudhary  </h5>
         <h6 class="text-muted font-16">Executive Member</h6>
      </div>
     
   </div>
</div>
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/7.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Amarnath Singh</h5>
         <h6 class="text-muted font-16">Executive Member</h6>
      </div>
     
   </div>
</div>
<div class="col-md-3">
   <div class="card Solutions-box">
     
      <div class="card-body text-center">
         <img src="/main/files/static/8.png" class="rounded-circle avatar-lg img-thumbnail" alt="profile-image"/>
         <h5 class="mb-0 mt-4">Mr. Pradeep Kumar Sharma </h5>
         <h6 class="text-muted font-16">Executive Member</h6>
      </div>
     
   </div>
</div>

                                    </div>
                                </div>
                            </section>
              

             


              
          
        </>
    )
}
export default Trustee;